import React from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import Page from "orion/lib/page";
import Sidebar from "orion/lib/sidebar";
import SideNav from "orion/lib/sideNav";
import { getMenus } from "../components/alertsSidebar";
import "../app.css";
import { useDruvaAlerts } from "../contexts/DruvaAlertsContext";

var AppLayoutContainer = function AppLayoutContainer(_ref) {
  var _ref$sideBarSite = _ref.sideBarSite,
      name = _ref$sideBarSite.name,
      icon = _ref$sideBarSite.icon,
      sideBarMenus = _ref.sideBarMenus;
  return /*#__PURE__*/React.createElement("div", {
    className: "alerts-parent-div"
  }, /*#__PURE__*/React.createElement(Page, null, /*#__PURE__*/React.createElement(Sidebar, {
    site: {
      name: name,
      icon: {
        src: icon
      }
    },
    sections: [{
      component: function component() {
        return /*#__PURE__*/React.createElement(SideNav, {
          items: getMenus(sideBarMenus)
        });
      }
    }],
    collapsible: true
  }), /*#__PURE__*/React.createElement(Outlet, null)));
};

AppLayoutContainer.propTypes = {
  sideBarSite: PropTypes.object.isRequired,
  sideBarMenus: PropTypes.array.isRequired
};
export default AppLayoutContainer;